import { useEffect, useState, useRef } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export default function ImageSlider({ currentGalerie, currentText, mdrMode, portraitMdr }) {
  const sliderRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setReady(false);
    setCurrentIndex(0);
    const timeout = setTimeout(() => {
      setReady(true);
      sliderRef.current?.resetTransform();
    }, 0);
    return () => clearTimeout(timeout);
  }, [currentGalerie]);

  const prevSlide = () => {
    setCurrentIndex((i) => (i === 0 ? currentGalerie.length - 1 : i - 1));
    sliderRef.current?.resetTransform();
  };

  const nextSlide = () => {
    setCurrentIndex((i) => (i === currentGalerie.length - 1 ? 0 : i + 1));
    sliderRef.current?.resetTransform();
  };

  return (
    <>
      <div className={mdrMode ? "flex-1 min-h-0 flex flex-col w-full" : "flex flex-col items-center justify-center w-full"}>
        {/* Portrait-MDR: 34vh statt 39vh — auf echten iPhones zählt vh die eingeklappte
            Browser-Chrome mit, wodurch Bild + Text + Buttonblock die sichtbare Höhe
            sprengten und der Text abgeschnitten wurde. Gilt NUR im MDR-Overlay
            (portraitMdr) — die Sidebar-Galerie bleibt beim originalen 39vh-Layout. */}
        <div className={`relative flex items-center justify-center w-full group bg-zinc-900 rounded-xl ${mdrMode ? "flex-1 min-h-0" : portraitMdr ? "h-[34vh]" : "h-[39vh]"}`}>
          <TransformWrapper
            ref={sliderRef}
            initialScale={1}
            minScale={1}
            maxScale={4}
            wheel={{ disabled: true }}
            pinch={{ disabled: false }}
            doubleClick={{ disabled: false }}
          >
            {() => (
              <TransformComponent
                wrapperClass="w-full"
                wrapperStyle={mdrMode ? { height: '100%', overflow: 'hidden' } : undefined}
                contentClass="w-full flex items-center justify-center"
                contentStyle={mdrMode ? { height: '100%' } : undefined}
              >
                {ready && currentGalerie[currentIndex] && (
                  <img
                    src={currentGalerie[currentIndex]}
                    alt="Museum"
                    className={`object-contain rounded-xl ${mdrMode ? "w-full h-full" : portraitMdr ? "w-auto h-[34vh]" : "w-auto h-[39vh]"}`}
                  />
                )}
              </TransformComponent>
            )}
          </TransformWrapper>

          <div
            className="group-hover:flex absolute top-1/2 -translate-y-1/2 left-0 text-2xl rounded-full p-2 bg-black/40 text-white cursor-pointer items-center justify-center"
            onClick={prevSlide}
          >
            <BsChevronCompactLeft size={25} />
          </div>

          <div
            className="group-hover:flex absolute top-1/2 -translate-y-1/2 right-0 text-2xl rounded-full p-2 bg-black/40 text-white cursor-pointer items-center justify-center"
            onClick={nextSlide}
          >
            <BsChevronCompactRight size={25} />
          </div>
        </div>

        <p style={portraitMdr
          /* Portrait-MDR: Text dicht ans Bild (4px, kein globales p-margin), damit er
             auf echten iPhones nicht unter den Buttonblock rutscht. */
          ? { fontFamily: 'Roboto, sans-serif', fontWeight: 300, fontSize: '12px', lineHeight: '1.25rem', letterSpacing: '0.025em', textAlign: 'center', alignSelf: 'center', color: 'white', padding: '4px 8px 0', width: '100%', margin: 0 }
          /* Sidebar/Desktop: originaler Abstand, unverändert. */
          : { fontFamily: 'Roboto, sans-serif', fontWeight: 300, fontSize: '12px', lineHeight: '1.25rem', letterSpacing: '0.025em', textAlign: 'center', color: 'white', padding: '12px 8px 0', width: '100%' }}>
          {currentText[currentIndex]}
        </p>
      </div>
    </>
  );
}
